import isPosIdChanged from './isPosIdChanged';
export default isPosIdChanged;
